export const Questions = [
  {
    question: "What does HTML stand for?",
    a: "Hyper Text Markup Language",
    b: "Hyperlink and Text Markup Language",
    c: "High Tech Markup Language",
    d: "Hyper Transfer Markup Language",
    answer: "a",
  },
  {
    question: "Which tag is used to create a hyperlink in HTML?",
    a: "<href>",
    b: "<link>",
    c: "<a>",
    d: "<hyper>",
    answer: "c",
  },
  {
    question: "What does the <canvas> element in HTML5 allow you to do?",
    a: "Embed audio content",
    b: "Create 2D shapes and graphics",
    c: "Define navigation links",
    d: "Style text content",
    answer: "b",
  },
  {
    question: "Which HTML tag is used to define an unordered list?",
    a: "<ol>",
    b: "<list>",
    c: "<ul>",
    d: "<order>",
    answer: "c",
  },
  {
    question: "What is the purpose of the <header> tag in HTML5?",
    a: "To create a new section in the document",
    b: "To define a footer for the document",
    c: "To mark the main content of the document",
    d: "To define introductory content, typically containing navigation links or logos",
    answer: "d",
  },
  {
    question: "What does CSS stand for in web development?",
    a: "Cascading Style Sheets",
    b: "Creative Style System",
    c: "Complete Styling Solution",
    d: "Computer Style Setup",
    answer: "a",
  },
  {
    question:
      "Which property is used to change the text color of an element in CSS?",
    a: "text-color",
    b: "color",
    c: "text-style",
    d: "font-color",
    answer: "b",
  },
  {
    question:
      "Which CSS property is used to create a shadow effect around an element's box?",
    a: "shadow-effect",
    b: "box-shadow",
    c: "element-shadow",
    d: "shadow-box",
    answer: "b",
  },
  {
    question: "What does the 'Cascading' in CSS refer to?",
    a: "It refers to the ability to apply multiple styles to an element.",
    b: "It refers to the hierarchical order of HTML elements.",
    c: "It refers to the process of combining multiple style sheets.",
    d: "It refers to the inheritance of styles from parent to child elements.",
    answer: "a",
  },
  {
    question:
      "Which CSS property is used to change the spacing between lines of text?",
    a: "text-spacing",
    b: "line-height",
    c: "text-line",
    d: "spacing",
    answer: "b",
  },
  {
    question: "What is JSX in React?",
    a: "JavaScript XML",
    b: "Extended JavaScript",
    c: "JavaScript Extension",
    d: "JavaScript XAML",
    answer: "a",
  },
  {
    question: "What is the purpose of the useState hook in React?",
    a: "To handle side effects in functional components",
    b: "To manage and update state in functional components",
    c: "To declare lifecycle methods in functional components",
    d: "To optimize rendering in functional components",
    answer: "b",
  },
  {
    question: "In React, what is a prop?",
    a: "A reserved keyword for defining components",
    b: "A way to pass data from parent to child components",
    c: "A method used to access component state",
    d: "A type of functional component in React",
    answer: "b",
  },
  {
    question:
      "What is the significance of the componentDidMount lifecycle method in React class components?",
    a: "It is invoked immediately after rendering occurs.",
    b: "It is used for updating component state.",
    c: "It is called before a component is removed from the DOM.",
    d: "It is invoked when a component is first mounted to the DOM.",
    answer: "d",
  },
  {
    question: "What is the purpose of a React Fragment ('<>...</>') in JSX?",
    a: "To define multi-line comments in JSX",
    b: "To group multiple elements without adding an extra node to the DOM",
    c: "To create an array of elements in JSX",
    d: "To define conditional rendering in JSX",
    answer: "b",
  },
  {
    question:
      "What is the primary function of version control systems like Git?",
    a: "Managing and tracking changes to files/code over time",
    b: "Optimizing website performance",
    c: "Running automated tests",
    d: "Deploying applications to servers",
    answer: "a",
  },
  {
    question: "What does a 'commit' represent in Git?",
    a: "A collection of changes to multiple files",
    b: "A backup of the entire repository",
    c: "A message describing the changes made to the repository",
    d: "A snapshot of the repository at a particular point in time",
    answer: "d",
  },
  {
    question: "What command is used to create a new branch in Git?",
    a: "git checkout -b <branch_name>",
    b: "git create-branch <branch_name>",
    c: "git branch new <branch_name>",
    d: "git branch-create <branch_name>",
    answer: "a",
  },
  {
    question: "What is the purpose of the Git command 'git merge'?",
    a: "To discard changes in the working directory",
    b: "To create a new branch from the current branch",
    c: "To combine changes from different branches into the current branch",
    d: "To delete a branch from the repository",
    answer: "c",
  },
  {
    question:
      "What is the Git command used to revert changes to a specific commit?",
    a: "git reset",
    b: "git checkout",
    c: "git revert",
    d: "git undo",
    answer: "c",
  },
];
